import React, { useState } from "react";
import {
	Box,
	Card,
	Typography,
	Divider,
	LinearProgress,
	Button,
	Avatar,
	Stack,
	IconButton,
	Tooltip,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SchoolIcon from "@mui/icons-material/School";
import EventIcon from "@mui/icons-material/Event";
import MenuBookIcon from "@mui/icons-material/MenuBook";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import BarChartIcon from "@mui/icons-material/BarChart";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TopBar from "../globalComponents/topbar";
import Footer from "../globalComponents/footer";
export default (props) => {
	const modules = [
		{
			id: 1,
			title: "Leadership Essentials",
			course: "Foundations of Leadership",
			date: "Mar 19, 2025",
			icon: <MenuBookIcon sx={{ color: "#1976d2" }} />,
		},
		{
			id: 2,
			title: "Data Analytics Basics",
			course: "Business Intelligence",
			date: "Mar 20, 2025",
			icon: <MenuBookIcon sx={{ color: "#0288d1" }} />,
		},
		{
			id: 3,
			title: "Team Communication",
			course: "Soft Skills Series",
			date: "Mar 23, 2025",
			icon: <MenuBookIcon sx={{ color: "#512da8" }} />,
		},
		{
			id: 4,
			title: "Strategic Thinking",
			course: "Leadership Mastery",
			date: "Mar 25, 2025",
			icon: <MenuBookIcon sx={{ color: "#d32f2f" }} />,
		},
	];
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div
				style={{
					height: 1323,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div
					style={{
						alignSelf: "stretch",
						display: "flex",
						alignItems: "flex-start",
					}}>
					<div
						style={{
							flexShrink: 0,
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>

						<div
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
					</div>
					<div
						style={{
							flex: 1,
							display: "flex",
							flexDirection: "column",
							gap: 32,
						}}>
						<TopBar />
						<div
							style={{
								alignSelf: "stretch",
								display: "flex",
								alignItems: "flex-start",
								marginLeft: 32,
								marginRight: 32,
							}}>
							<span
								style={{
									color: "#010101",
									fontSize: 40,
									fontWeight: "bold",
									flex: 1,
								}} >
								{"Progress Tracking Dashboard"}
							</span>
							<span
								style={{
									color: "#6C6C6C",
									fontSize: 18,
									marginTop: 20,
								}} >
								{"Welcome Back, John Doe!"}
							</span>
						</div>
						<div
							style={{
								alignSelf: "stretch",
								display: "flex",
								alignItems: "flex-start",
								marginLeft: 32,
								marginRight: 32,
								gap: 12,
							}}>
							{/* <div 
								style={{
									flex: 1,
									display: "flex",
									flexDirection: "column",
									gap: 32,
								}}>
								<div 
									style={{
										alignSelf: "stretch",
										background: "#FFFFFF",
										borderRadius: 12,
										paddingTop: 20,
										paddingBottom: 20,
										boxShadow: "0px 1px 3px #00000003",
									}}>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "center",
											marginBottom: 20,
											marginLeft: 20,
											marginRight: 20,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 20,
												fontWeight: "bold",
												flex: 1,
											}} >
											{"Overall Progress Overview"}
										</span>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "center",
												gap: 8,
											}}>
											<span 
												style={{
													color: "#979797",
													fontSize: 14,
													fontWeight: "bold",
												}} >
												{"View all"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6gbctr4p_expires_30_days.png"} 
												style={{
													width: 9,
													height: 9,
													objectFit: "fill",
												}}
											/>
										</div>
									</div>
									<div 
										style={{
											height: 1,
											alignSelf: "stretch",
											background: "#E6E6E6",
											marginBottom: 25,
											marginLeft: 20,
											marginRight: 20,
										}}>
									</div>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
											borderRadius: 12,
											paddingTop: 16,
											paddingBottom: 16,
											marginLeft: 22,
											marginRight: 22,
										}}>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												alignItems: "flex-start",
												marginBottom: 14,
												marginLeft: 28,
												marginRight: 28,
											}}>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 14,
													fontWeight: "bold",
													flex: 1,
												}} >
												{"Course Complete"}
											</span>
											<span 
												style={{
													color: "#0BBB0D",
													fontSize: 14,
													fontWeight: "bold",
												}} >
												{"65%"}
											</span>
										</div>
										<div 
											style={{
												alignSelf: "stretch",
												background: "#96DEF8",
												borderRadius: 4,
												marginBottom: 12,
												marginLeft: 28,
												marginRight: 28,
											}}>
											<div 
												style={{
													height: 8,
													alignSelf: "stretch",
													background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
													borderTopLeftRadius: 4,
													borderBottomLeftRadius: 4,
												}}>
											</div>
										</div>
										<span 
											style={{
												color: "#00AEEF",
												fontSize: 12,
												fontWeight: "bold",
												marginLeft: 28,
											}} >
											{"You’ve learned for 3 consecutive days!"}
										</span>
									</div>
								</div>
								<div 
									style={{
										alignSelf: "stretch",
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										paddingTop: 20,
										paddingBottom: 20,
										boxShadow: "0px 1px 3px #00000003",
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 20,
											fontWeight: "bold",
											marginBottom: 20,
											marginLeft: 20,
										}} >
										{"Areas of Strength & Weakness"}
									</span>
									<div 
										style={{
											height: 1,
											alignSelf: "stretch",
											background: "#E6E6E6",
											marginBottom: 23,
											marginLeft: 20,
											marginRight: 20,
										}}>
									</div>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#E7F1F880",
											borderRadius: 8,
											border: `1px solid #9DC6E4`,
											paddingTop: 12,
											paddingBottom: 12,
											marginBottom: 12,
											marginLeft: 21,
											marginRight: 21,
											gap: 6,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 12,
												fontWeight: "bold",
												marginLeft: 22,
											}} >
											{"Strengths"}
										</span>
										<span 
											style={{
												color: "#1074BC",
												fontSize: 12,
												fontWeight: "bold",
												marginLeft: 22,
											}} >
											{"You excel in Market Research and Business Planning!"}
										</span>
									</div>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FEF0E980",
											borderRadius: 8,
											border: `1px solid #FABFA4`,
											paddingTop: 12,
											paddingBottom: 12,
											marginLeft: 21,
											marginRight: 21,
											gap: 6,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 12,
												fontWeight: "bold",
												marginLeft: 22,
											}} >
											{"Weaknesses"}
										</span>
										<span 
											style={{
												color: "#F36421",
												fontSize: 12,
												fontWeight: "bold",
												marginLeft: 22,
											}} >
											{"You excel in Market Research and Business Planning!"}
										</span>
									</div>
								</div>
							</div> */}
							<Box
								sx={{
									flex: 1,
									display: "flex",
									flexDirection: "column",
									gap: 4,
								}}
							>
								{/* -------- Overall Progress Overview -------- */}
								<Card
									sx={{
										borderRadius: 3,
										p: 2.5,
										boxShadow: "0px 1px 3px #00000003",
									}}
								>
									{/* Header */}
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											mb: 2.5,
											mx: 2,
										}}
									>
										<Typography sx={{ flex: 1, fontWeight: "bold", fontSize: 20 }}>
											Overall Progress Overview
										</Typography>
										<Stack direction="row" spacing={1} alignItems="center">
											<Typography sx={{ color: "#979797", fontSize: 14, fontWeight: "bold" }}>
												View all
											</Typography>
											<ArrowForwardIosIcon sx={{ fontSize: 12, color: "#979797" }} />
										</Stack>
									</Box>

									<Divider sx={{ mx: 2, mb: 3, bgcolor: "#E6E6E6" }} />

									{/* Course Completion Card */}
									<Box
										sx={{
											mx: 2,
											borderRadius: 2,
											background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
											p: 2,
										}}
									>
										<Stack spacing={1.5}>
											{/* Progress Text */}
											<Box display="flex" justifyContent="space-between" mx={2}>
												<Typography sx={{ fontWeight: "bold", fontSize: 14, color: "#2C2C2C" }}>
													Course Complete
												</Typography>
												<Typography sx={{ fontWeight: "bold", fontSize: 14, color: "#0BBB0D" }}>
													65%
												</Typography>
											</Box>

											{/* Progress Bar */}
											<Box
												sx={{
													mx: 2,
													height: 8,
													borderRadius: 1,
													background: "#96DEF8",
												}}
											>
												<Box
													sx={{
														width: "65%",
														height: "100%",
														borderRadius: 1,
														background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
													}}
												/>
											</Box>

											<Typography
												sx={{
													color: "#00AEEF",
													fontSize: 12,
													fontWeight: "bold",
													mx: 2,
												}}
											>
												You’ve learned for 3 consecutive days!
											</Typography>
										</Stack>
									</Box>
								</Card>

								{/* -------- Strengths & Weakness -------- */}
								<Card
									sx={{
										borderRadius: 3,
										p: 2.5,
										boxShadow: "0px 1px 3px #00000003",
									}}
								>
									<Typography
										sx={{
											fontWeight: "bold",
											fontSize: 20,
											mb: 2.5,
											ml: 2,
											color: "#010101",
										}}
									>
										Areas of Strength & Weakness
									</Typography>

									<Divider sx={{ mx: 2, mb: 3, bgcolor: "#E6E6E6" }} />

									{/* Strengths Section */}
									<Box
										sx={{
											mx: 2,
											mb: 1.5,
											p: 1.5,
											borderRadius: 2,
											border: "1px solid #9DC6E4",
											background: "#E7F1F880",
										}}
									>
										<Typography
											sx={{
												color: "#010101",
												fontSize: 12,
												fontWeight: "bold",
												mb: 0.5,
											}}
										>
											Strengths
										</Typography>
										<Typography sx={{ color: "#1074BC", fontSize: 12, fontWeight: "bold" }}>
											You excel in Market Research and Business Planning!
										</Typography>
									</Box>

									{/* Weaknesses Section */}
									<Box
										sx={{
											mx: 2,
											p: 1.5,
											borderRadius: 2,
											border: "1px solid #FABFA4",
											background: "#FEF0E980",
										}}
									>
										<Typography
											sx={{
												color: "#010101",
												fontSize: 12,
												fontWeight: "bold",
												mb: 0.5,
											}}
										>
											Weaknesses
										</Typography>
										<Typography sx={{ color: "#F36421", fontSize: 12, fontWeight: "bold" }}>
											You need improvement in Financial Management and Strategy.
										</Typography>
									</Box>
								</Card>
							</Box>
							{/* <div
								style={{
									flex: 1,
									background: "#FFFFFF",
									borderRadius: 12,
									paddingTop: 20,
									paddingBottom: 84,
									boxShadow: "0px 1px 3px #00000003",
								}}>
								<div
									style={{
										alignSelf: "stretch",
										display: "flex",
										alignItems: "center",
										marginBottom: 20,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<span
										style={{
											color: "#010101",
											fontSize: 20,
											fontWeight: "bold",
											flex: 1,
										}} >
										{"Completed Modules & Lessons"}
									</span>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											gap: 8,
										}}>
										<span
											style={{
												color: "#979797",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"View all"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ugix6lgu_expires_30_days.png"}
											style={{
												width: 9,
												height: 9,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
								<div
									style={{
										height: 1,
										alignSelf: "stretch",
										background: "#E6E6E6",
										marginBottom: 23,
										marginLeft: 20,
										marginRight: 20,
									}}>
								</div>
								<div
									style={{
										alignSelf: "stretch",
										display: "flex",
										flexDirection: "column",
										marginLeft: 20,
										marginRight: 20,
										gap: 16,
									}}>
									<div
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "center",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											padding: 14,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9s3m3aus_expires_30_days.png"}
											style={{
												width: 40,
												height: 40,
												marginRight: 10,
												objectFit: "fill",
											}}
										/>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 6,
											}}>
											<span
												style={{
													color: "#010101",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Module Name"}
											</span>
											<span
												style={{
													color: "#F36421",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Course name"}
											</span>
										</div>
										<div
											style={{
												flex: 1,
												alignSelf: "stretch",
											}}>
										</div>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 3,
											}}>
											<div
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-end",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v1ulq6vi_expires_30_days.png"}
													style={{
														width: 21,
														height: 21,
														marginRight: 5,
														objectFit: "fill",
													}}
												/>
											</div>
											<span
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Mar 19, 2025"}
											</span>
										</div>
									</div>
									<div
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "center",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											padding: 14,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/umlhjnvk_expires_30_days.png"}
											style={{
												width: 40,
												height: 40,
												marginRight: 10,
												objectFit: "fill",
											}}
										/>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 6,
											}}>
											<span
												style={{
													color: "#010101",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Module Name"}
											</span>
											<span
												style={{
													color: "#F36421",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Course name"}
											</span>
										</div>
										<div
											style={{
												flex: 1,
												alignSelf: "stretch",
											}}>
										</div>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 3,
											}}>
											<div
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-end",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9jw6ysxg_expires_30_days.png"}
													style={{
														width: 21,
														height: 21,
														marginRight: 5,
														objectFit: "fill",
													}}
												/>
											</div>
											<span
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Mar 19, 2025"}
											</span>
										</div>
									</div>
									<div
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "center",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											padding: 14,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0cndacmm_expires_30_days.png"}
											style={{
												width: 40,
												height: 40,
												marginRight: 10,
												objectFit: "fill",
											}}
										/>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 6,
											}}>
											<span
												style={{
													color: "#010101",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Module Name"}
											</span>
											<span
												style={{
													color: "#F36421",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Course name"}
											</span>
										</div>
										<div
											style={{
												flex: 1,
												alignSelf: "stretch",
											}}>
										</div>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 3,
											}}>
											<div
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-end",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/f2n8hfyu_expires_30_days.png"}
													style={{
														width: 21,
														height: 21,
														marginRight: 5,
														objectFit: "fill",
													}}
												/>
											</div>
											<span
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Mar 19, 2025"}
											</span>
										</div>
									</div>
									<div
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "center",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											padding: 14,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2xc6mrp7_expires_30_days.png"}
											style={{
												width: 40,
												height: 40,
												marginRight: 10,
												objectFit: "fill",
											}}
										/>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 6,
											}}>
											<span
												style={{
													color: "#010101",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Module Name"}
											</span>
											<span
												style={{
													color: "#F36421",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Course name"}
											</span>
										</div>
										<div
											style={{
												flex: 1,
												alignSelf: "stretch",
											}}>
										</div>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 3,
											}}>
											<div
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-end",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/b845qbll_expires_30_days.png"}
													style={{
														width: 21,
														height: 21,
														marginRight: 5,
														objectFit: "fill",
													}}
												/>
											</div>
											<span
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Mar 19, 2025"}
											</span>
										</div>
									</div>
								</div>
							</div> */}
							<Card
								sx={{
									flex: 1,
									backgroundColor: "#FFFFFF",
									borderRadius: 3,
									pt: 3,
									pb: 5,
									boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
								}}
							>
								{/* Header */}
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										mb: 2,
										px: 3,
									}}
								>
									<Typography
										sx={{
											color: "#010101",
											fontSize: 20,
											fontWeight: 700,
											flex: 1,
										}}
									>
										Completed Modules & Lessons
									</Typography>
									<Stack direction="row" spacing={1} alignItems="center">
										<Typography
											sx={{ color: "#979797", fontSize: 14, fontWeight: "bold" }}
										>
											View all
										</Typography>
										<ArrowForwardIosIcon sx={{ fontSize: 13, color: "#979797" }} />
									</Stack>
								</Box>

								<Divider sx={{ mx: 3, mb: 3, bgcolor: "#E6E6E6" }} />

								{/* Module List */}
								<Stack spacing={2} sx={{ mx: 3 }}>
									{modules.map((mod) => (
										<Box
											key={mod.id}
											sx={{
												display: "flex",
												alignItems: "center",
												backgroundColor: "#FAFAFA",
												borderRadius: 2,
												border: "1px solid #E6E6E6",
												p: 1.8,
												transition: "0.2s",
												"&:hover": {
													backgroundColor: "#F3F8FF",
													boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
												},
											}}
										>
											{/* Module Icon */}
											<Avatar
												sx={{
													width: 46,
													height: 46,
													bgcolor: "#E3F2FD",
													mr: 2,
												}}
											>
												{mod.icon}
											</Avatar>

											{/* Module Info */}
											<Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
												<Typography
													sx={{ color: "#010101", fontSize: 14, fontWeight: "bold" }}
												>
													{mod.title}
												</Typography>

												<Stack direction="row" spacing={1} alignItems="center">
													<SchoolIcon sx={{ color: "#F36421", fontSize: 14 }} />
													<Typography
														sx={{ color: "#F36421", fontSize: 12, fontWeight: "bold" }}
													>
														{mod.course}
													</Typography>
												</Stack>
											</Box>

											{/* Spacer */}
											<Box sx={{ flex: 1 }} />

											{/* Right Section */}
											<Stack alignItems="flex-end" spacing={0.5}>
												<Tooltip title="Module Completed">
													<IconButton size="small" sx={{ p: 0 }}>
														<CheckCircleIcon sx={{ color: "#00AEEF", fontSize: 22 }} />
													</IconButton>
												</Tooltip>

												<Stack direction="row" spacing={0.5} alignItems="center">
													<EventIcon sx={{ fontSize: 13, color: "#6C6C6C" }} />
													<Typography
														sx={{ color: "#6C6C6C", fontSize: 11, fontWeight: "bold" }}
													>
														{mod.date}
													</Typography>
												</Stack>
											</Stack>
										</Box>
									))}
								</Stack>
							</Card>
						</div>
						{/* <div
							style={{
								alignSelf: "stretch",
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								borderRadius: 12,
								paddingTop: 20,
								paddingBottom: 39,
								marginLeft: 32,
								marginRight: 32,
								boxShadow: "0px 1px 3px #00000003",
							}}>
							<span
								style={{
									color: "#010101",
									fontSize: 20,
									fontWeight: "bold",
									marginBottom: 20,
									marginLeft: 20,
								}} >
								{"Analytics Activity"}
							</span>
							<div
								style={{
									height: 1,
									alignSelf: "stretch",
									background: "#E6E6E6",
									marginBottom: 19,
									marginLeft: 20,
									marginRight: 20,
								}}>
							</div>
							<span
								style={{
									color: "#2C2C2C",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 16,
									marginLeft: 21,
								}} >
								{"Time Spent Learning"}
							</span>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 29,
									marginLeft: 21,
									gap: 15,
								}}>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
										borderRadius: 8,
										paddingTop: 12,
										paddingBottom: 12,
										gap: 6,
									}}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
											marginLeft: 23,
										}} >
										{"Total"}
									</span>
									<div
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 23,
											marginRight: 23,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kv9ulrer_expires_30_days.png"}
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span
											style={{
												color: "#00AEEF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"12 hours 45 minutes"}
										</span>
									</div>
								</div>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
										borderRadius: 8,
										paddingTop: 12,
										paddingBottom: 12,
										gap: 6,
									}}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
											marginLeft: 23,
										}} >
										{"This week"}
									</span>
									<div
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 23,
											marginRight: 23,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/woify1ui_expires_30_days.png"}
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span
											style={{
												color: "#00AEEF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"12 hours 45 minutes"}
										</span>
									</div>
								</div>
							</div>
							<div
								style={{
									alignSelf: "stretch",
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 21,
									marginRight: 21,
								}}>
								<span
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 204,
										width: 131,
									}} >
									{"Daily Activity Graph"}
								</span>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										textAlign: "right",
										marginRight: 71,
										width: 179,
									}} >
									{"Average this week 7-8"}
								</span>
								<span
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										width: 121,
									}} >
									{"Completion Graph"}
								</span>
								<div
									style={{
										flex: 1,
										alignSelf: "stretch",
									}}>
								</div>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										paddingTop: 4,
										paddingBottom: 4,
										gap: 4,
									}}>
									<span
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Weekly"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8tm3f286_expires_30_days.png"}
										style={{
											width: 9,
											height: 5,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div
								style={{
									alignSelf: "stretch",
									display: "flex",
									alignItems: "center",
									marginLeft: 21,
									marginRight: 21,
								}}>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										textAlign: "right",
										marginRight: 15,
										width: 31,
									}} >
									{"9-10"}
								</span>
								<div
									style={{
										width: 468,
										height: 1,
										background: "#E6E6E6",
										marginRight: 72,
									}}>
								</div>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										marginRight: 10,
									}} >
									{"100%"}
								</span>
								<div
									style={{
										height: 1,
										flex: 1,
										background: "#E6E6E6",
									}}>
								</div>
							</div>
							<div
								style={{
									alignSelf: "stretch",
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 4,
									marginLeft: 21,
									marginRight: 21,
								}}>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										marginTop: 22,
										marginRight: 15,
										gap: 22,
									}}>
									<span
										style={{
											color: "#979797",
											fontSize: 10,
											textAlign: "right",
											width: 31,
										}} >
										{"7-8"}
									</span>
									<span
										style={{
											color: "#979797",
											fontSize: 10,
											textAlign: "right",
											width: 31,
										}} >
										{"5-6"}
									</span>
									<span
										style={{
											color: "#979797",
											fontSize: 10,
											textAlign: "right",
											width: 31,
										}} >
										{"3-4"}
									</span>
									<span
										style={{
											color: "#979797",
											fontSize: 10,
											textAlign: "right",
											width: 31,
										}} >
										{"1-2"}
									</span>
								</div>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										marginRight: 76,
										gap: 1,
									}}>
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											position: "relative",
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vcr1het0_expires_30_days.png"}
											style={{
												width: 468,
												height: 149,
												objectFit: "fill",
											}}
										/>
										<div
											style={{
												position: "absolute",
												top: 31,
												left: 0,
												width: 468,
												height: 1,
												background: "#E6E6E6",
											}}>
										</div>
										<div
											style={{
												position: "absolute",
												top: 70,
												left: 0,
												width: 468,
												height: 1,
												background: "#E6E6E6",
											}}>
										</div>
										<div
											style={{
												position: "absolute",
												bottom: 37,
												left: 0,
												width: 468,
												height: 1,
												background: "#E6E6E6",
											}}>
										</div>
									</div>
									<div
										style={{
											width: 468,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
								</div>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										marginTop: 16,
										marginRight: 9,
										gap: 19,
									}}>
									<span
										style={{
											color: "#979797",
											fontSize: 10,
										}} >
										{"80%"}
									</span>
									<span
										style={{
											color: "#979797",
											fontSize: 10,
										}} >
										{"60%"}
									</span>
									<span
										style={{
											color: "#979797",
											fontSize: 10,
										}} >
										{"40%"}
									</span>
									<span
										style={{
											color: "#979797",
											fontSize: 10,
										}} >
										{"20%"}
									</span>
									<span
										style={{
											color: "#979797",
											fontSize: 10,
										}} >
										{"0%"}
									</span>
								</div>
								<div
									style={{
										flex: 1,
										display: "flex",
										flexDirection: "column",
										marginTop: 7,
										marginBottom: 7,
										gap: 1,
									}}>
									<div
										style={{
											alignSelf: "stretch",
											display: "flex",
											flexDirection: "column",
											position: "relative",
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/d6daec20_expires_30_days.png"}
											style={{
												height: 147,
												alignSelf: "stretch",
												objectFit: "fill",
											}}
										/>
										<div
											style={{
												position: "absolute",
												top: 15,
												right: 0,
												left: 0,
												height: 1,
												alignSelf: "stretch",
												background: "#E6E6E6",
											}}>
										</div>
										<div
											style={{
												position: "absolute",
												top: 48,
												right: 0,
												left: 0,
												height: 1,
												alignSelf: "stretch",
												background: "#E6E6E6",
											}}>
										</div>
										<div
											style={{
												position: "absolute",
												bottom: 64,
												right: 0,
												left: 0,
												height: 1,
												alignSelf: "stretch",
												background: "#E6E6E6",
											}}>
										</div>
										<div
											style={{
												position: "absolute",
												bottom: 30,
												right: 0,
												left: 0,
												height: 1,
												alignSelf: "stretch",
												background: "#E6E6E6",
											}}>
										</div>
									</div>
									<div
										style={{
											height: 1,
											alignSelf: "stretch",
											background: "#E6E6E6",
										}}>
									</div>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									marginLeft: 67,
								}}>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										textAlign: "right",
										marginRight: 43,
										width: 35,
									}} >
									{"MON"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										textAlign: "right",
										marginRight: 53,
										width: 18,
									}} >
									{"TUE"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										textAlign: "right",
										marginRight: 43,
										width: 32,
									}} >
									{"WED"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										textAlign: "right",
										marginRight: 44,
										width: 31,
									}} >
									{"THU"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										textAlign: "right",
										marginRight: 52,
										width: 13,
									}} >
									{"FRI"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										textAlign: "right",
										marginRight: 54,
										width: 17,
									}} >
									{"SAT"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										textAlign: "right",
										marginRight: 118,
										width: 31,
									}} >
									{"SUN"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										marginRight: 43,
									}} >
									{"MON"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										marginRight: 53,
									}} >
									{"TUE"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										marginRight: 43,
									}} >
									{"WED"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										marginRight: 44,
									}} >
									{"THU"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										marginRight: 52,
									}} >
									{"FRI"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
										marginRight: 54,
									}} >
									{"SAT"}
								</span>
								<span
									style={{
										color: "#979797",
										fontSize: 10,
									}} >
									{"SUN"}
								</span>
							</div>
						</div> */}
						<Card
							sx={{
								backgroundColor: "#FFFFFF",
								borderRadius: 3,
								boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
								px: 4,
								py: 3,
								flex: 1,
							}}
						>
							{/* Header */}
							<Typography
								variant="h6"
								sx={{ fontWeight: "bold", color: "#010101", mb: 2 }}
							>
								Analytics Activity
							</Typography>
							<Divider sx={{ bgcolor: "#E6E6E6", mb: 3 }} />

							{/* Time Spent Section */}
							<Stack spacing={1} sx={{ mb: 3 }}>
								<Stack direction="row" alignItems="center" spacing={1}>
									<AccessTimeIcon sx={{ color: "#00AEEF", fontSize: 20 }} />
									<Typography sx={{ fontWeight: "bold", color: "#2C2C2C" }}>
										Time Spent Learning
									</Typography>
								</Stack>

								<Stack direction="row" spacing={2} sx={{ mt: 1 }}>
									{/* Total */}
									<Box
										sx={{
											background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
											borderRadius: 2,
											px: 3,
											py: 1.5,
											flex: 1,
										}}
									>
										<Typography sx={{ fontWeight: "bold", fontSize: 12, color: "#2C2C2C" }}>
											Total
										</Typography>
										<Stack direction="row" alignItems="center" spacing={1}>
											<AccessTimeIcon sx={{ fontSize: 15, color: "#00AEEF" }} />
											<Typography sx={{ color: "#00AEEF", fontSize: 12, fontWeight: "bold" }}>
												12 hours 45 minutes
											</Typography>
										</Stack>
									</Box>

									{/* This Week */}
									<Box
										sx={{
											background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
											borderRadius: 2,
											px: 3,
											py: 1.5,
											flex: 1,
										}}
									>
										<Typography sx={{ fontWeight: "bold", fontSize: 12, color: "#2C2C2C" }}>
											This Week
										</Typography>
										<Stack direction="row" alignItems="center" spacing={1}>
											<AccessTimeIcon sx={{ fontSize: 15, color: "#00AEEF" }} />
											<Typography sx={{ color: "#00AEEF", fontSize: 12, fontWeight: "bold" }}>
												5 hours 30 minutes
											</Typography>
										</Stack>
									</Box>
								</Stack>
							</Stack>

							{/* Analytics Summary Row */}
							<Stack
								direction="row"
								alignItems="center"
								justifyContent="space-between"
								sx={{ mb: 3 }}
							>
								<Stack direction="row" alignItems="center" spacing={1}>
									<ShowChartIcon sx={{ fontSize: 20, color: "#1976d2" }} />
									<Typography sx={{ fontWeight: "bold", fontSize: 14, color: "#2C2C2C" }}>
										Daily Activity Graph
									</Typography>
								</Stack>

								<Typography sx={{ color: "#6C6C6C", fontSize: 12 }}>
									Average this week: 7–8 hrs
								</Typography>

								<Stack direction="row" alignItems="center" spacing={1}>
									<DonutLargeIcon sx={{ color: "#F36421", fontSize: 20 }} />
									<Typography sx={{ fontWeight: "bold", fontSize: 14, color: "#2C2C2C" }}>
										Completion Graph
									</Typography>
								</Stack>

								<Stack direction="row" alignItems="center" spacing={0.5}>
									<Typography sx={{ fontSize: 12, color: "#6C6C6C", fontWeight: "bold" }}>
										Weekly
									</Typography>
									<ArrowDropDownIcon sx={{ fontSize: 16, color: "#6C6C6C" }} />
								</Stack>
							</Stack>

							{/* Placeholder Charts */}
							<Box
								sx={{
									display: "flex",
									gap: 4,
									mb: 3,
									flexWrap: "wrap",
								}}
							>
								{/* Daily Graph */}
								<Box
									sx={{
										flex: 1,
										height: 160,
										border: "1px solid #E6E6E6",
										borderRadius: 2,
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										background: "linear-gradient(180deg, #FAFAFA, #FFFFFF)",
									}}
								>
									<ShowChartIcon sx={{ fontSize: 40, color: "#00AEEF" }} />
									<Typography sx={{ ml: 1, fontSize: 12, color: "#6C6C6C" }}>
										(Graph placeholder)
									</Typography>
								</Box>

								{/* Completion Graph */}
								<Box
									sx={{
										flex: 1,
										height: 160,
										border: "1px solid #E6E6E6",
										borderRadius: 2,
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										background: "linear-gradient(180deg, #FAFAFA, #FFFFFF)",
									}}
								>
									<DonutLargeIcon sx={{ fontSize: 40, color: "#F36421" }} />
									<Typography sx={{ ml: 1, fontSize: 12, color: "#6C6C6C" }}>
										(Graph placeholder)
									</Typography>
								</Box>
							</Box>

							{/* Footer (Days Row) */}
							<Stack direction="row" justifyContent="center" spacing={3}>
								{["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].map((day) => (
									<Typography key={day} sx={{ fontSize: 10, color: "#979797" }}>
										{day}
									</Typography>
								))}
							</Stack>
						</Card>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	)
}